<ion-header class="ion-no-border">
  <ion-toolbar *ngIf="title">
    <ion-title class="font18 font600 text-color">{{title}}</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" color="dark" (click)="closeModal()">
        <ion-icon
          slot="icon-only"
          name="close"
          class="primary-icon-color"
        ></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-no-padding">
  <div
    class="ion-no-padding fs-2 font500 hotel-deals-status-badge-text-color l-height19 ion-padding-horizontal ion-padding-bottom"
    [innerHtml]="safeHtmlContent"
  ></div>
</ion-content>